import { startIdpProcess } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type { DosespotIDPRecordT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';
import { logger } from '@/shared';

/**
 * Start the IDP (identity proofing) process for the authenticated user.
 */
export async function fetchStartIdpProcess(signal?: AbortSignal): Promise<DosespotIDPRecordT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await startIdpProcess(config);
  const data = lotusHealthZod.startIdpProcessResponse.parse(response.data) as DosespotIDPRecordT;

  logger.info('dosespot.idp.start', {
    source: 'entities/dosespot-idp/api',
    currentState: data.current_state,
  });

  return data;
}
